import "core-js/modules/es.array.push.js";
import countTo from 'vue-count-to';
import { mapGetters } from 'vuex';
import { getComponent, getAssiationInterface } from '@/api/modules/personal.js';
export default {
  props: {
    _id: String
  },
  components: {
    countTo
  },
  data() {
    return {
      info: {},
      associated_interface: []
    };
  },
  computed: {
    ...mapGetters(['productList']),
    productType() {
      if (this.productList.find(item => item.product_code === 'interface')) {
        if (Object.keys(this.productList.find(item => item.product_code === 'interface')).length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    // 获取组件详情
    getComponentDetail() {
      getComponent({
        _id: this._id
      }).then(res => {
        if (res.code === 1) {
          this.info = {
            ...res.result
          };
          this.getAssociatedInterface(this.info.component_name || '');
        }
      });
    },
    goBack() {
      this.$router.back();
    },
    // 获取关联接口
    getAssociatedInterface(name) {
      getAssiationInterface({
        name
      }).then(res => {
        if (res.code === 1) {
          this.associated_interface = res.result;
        }
      });
    },
    // 跳转接口
    goInterface(item) {
      this.$router.push({
        path: '/service/details',
        query: {
          type: 'interface',
          _id: item._id,
          group_code: item === null || item === void 0 ? void 0 : item.category[0].group_code
        }
      });
    }
    // addOrderList(){
    //   this.$emit('addOrderList', {
    //     product_code: this.info._id,
    //     product_type: this.info.product_type
    //   });
    // },
  },
  watch: {
    _id: {
      handler(val) {
        if (val) {
          this.getComponentDetail();
        }
      },
      immediate: true
    }
  }
};